import { SEARCH_NAMES } from "constant/search/search";
import { getObjectTypeValues } from "type/common/type_util";

export const USER_TYPE = {
  ADMIN: "admin",
  REDAKTOR: "redaktor",
} as const;

const userTypes = getObjectTypeValues(USER_TYPE);

export type UserType = (typeof userTypes)[number];

export const USER_PER_PAGE_MAX = 10;

export const USER_SEARCH_OPTIONS = [
  SEARCH_NAMES.SEARCH_TEXT,
  SEARCH_NAMES.LIMIT,
  SEARCH_NAMES.SKIP,
] as const;

export type UserSearchOptions = (typeof USER_SEARCH_OPTIONS)[number];
